/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G–C pairs have three hydrogen bonds versus two for A–T, so higher GC content raises the melting temperature and stability of DNA. It also affects PCR primer design and reflects genome characteristics.`)
};

const es_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los pares G-C tienen tres enlaces de hidrógeno frente a dos de A-T, por lo que un mayor contenido GC aumenta la temperatura de fusión y la estabilidad del ADN. También afecta al diseño de cebadores de PCR y refleja características del genoma.`)
};

const de_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-C-Paare haben drei Wasserstoffbrücken gegenüber zwei bei A-T, sodass ein höherer GC-Gehalt die Schmelztemperatur und Stabilität der DNA erhöht. Er beeinflusst auch das Design von PCR-Primern und spiegelt Genommerkmale wider.`)
};

const nl_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-C-paren hebben drie waterstofbruggen tegenover twee voor A-T, dus een hoger GC-gehalte verhoogt de smelttemperatuur en stabiliteit van DNA. Het beïnvloedt ook het ontwerp van PCR-primers en weerspiegelt genoomkenmerken.`)
};

const fr_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les paires G-C ont trois liaisons hydrogène contre deux pour A-T, donc un contenu GC plus élevé augmente la température de fusion et la stabilité de l'ADN. Il affecte aussi la conception des amorces PCR et reflète les caractéristiques du génome.`)
};

const it_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le coppie G-C hanno tre legami idrogeno contro i due delle coppie A-T, quindi un contenuto GC più alto aumenta la temperatura di fusione e la stabilità del DNA. Influisce anche sulla progettazione dei primer per PCR e riflette le caratteristiche del genoma.`)
};

const pt_br2_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pares G-C têm três ligações de hidrogênio contra duas dos pares A-T, então um conteúdo GC maior eleva a temperatura de fusão e a estabilidade do DNA. Também afeta o desenho de primers de PCR e reflete características do genoma.`)
};

const pt_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pares G–C têm três ligações de hidrogénio contra duas dos pares A–T, pelo que um conteúdo GC mais elevado aumenta a temperatura de fusão e a estabilidade do ADN. Também afeta o desenho de primers para PCR e reflete características do genoma.`)
};

const ja_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G-C対はA-Tの2つに対して3つの水素結合を持つため、GC含量が高いほどDNAの融解温度と安定性が上がります。また、PCRプライマー設計にも影響し、ゲノムの特徴を反映します。`)
};

const zh_gc_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`G–C 配对有三个氢键，而 A–T 只有两个，因此 GC 含量越高，DNA 的解链温度和稳定性也越高。它还会影响 PCR 引物设计，并反映基因组特征。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_faq_a2", locale)
	if (locale === "en") return en_gc_faq_a2(inputs)
	if (locale === "es") return es_gc_faq_a2(inputs)
	if (locale === "de") return de_gc_faq_a2(inputs)
	if (locale === "nl") return nl_gc_faq_a2(inputs)
	if (locale === "fr") return fr_gc_faq_a2(inputs)
	if (locale === "it") return it_gc_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_gc_faq_a2(inputs)
	if (locale === "pt") return pt_gc_faq_a2(inputs)
	if (locale === "ja") return ja_gc_faq_a2(inputs)
	return zh_gc_faq_a2(inputs)
};